/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Sandbox1Inputs */

const id_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ms_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const da_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const de_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const en_us2_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const es_es2_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const es_mx2_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const fil_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const fr_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const it_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const hu_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const nl_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const no_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const pl_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const pt_br2_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const pt_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ro_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const fi_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiekkalaatikko`)
};

const sv_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandlåda`)
};

const vi_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const tr_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const cs_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const bg_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ru_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Песочница`)
};

const uk_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ar_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const hi_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स`)
};

const th_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แซนด์บ็อกซ์`)
};

const ja_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックス`)
};

const zh_cn2_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const zh_hant1_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ko_components_sandboxshell_sandbox1 = /** @type {(inputs: Components_Sandboxshell_Sandbox1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

/**
* | output |
* | --- |
* | "Sandbox" |
*
* @param {Components_Sandboxshell_Sandbox1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_sandbox1 = /** @type {((inputs?: Components_Sandboxshell_Sandbox1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Sandbox1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_sandbox1(inputs)
	if (locale === "ms") return ms_components_sandboxshell_sandbox1(inputs)
	if (locale === "da") return da_components_sandboxshell_sandbox1(inputs)
	if (locale === "de") return de_components_sandboxshell_sandbox1(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_sandbox1(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_sandbox1(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_sandbox1(inputs)
	if (locale === "fil") return fil_components_sandboxshell_sandbox1(inputs)
	if (locale === "fr") return fr_components_sandboxshell_sandbox1(inputs)
	if (locale === "it") return it_components_sandboxshell_sandbox1(inputs)
	if (locale === "hu") return hu_components_sandboxshell_sandbox1(inputs)
	if (locale === "nl") return nl_components_sandboxshell_sandbox1(inputs)
	if (locale === "no") return no_components_sandboxshell_sandbox1(inputs)
	if (locale === "pl") return pl_components_sandboxshell_sandbox1(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_sandbox1(inputs)
	if (locale === "pt") return pt_components_sandboxshell_sandbox1(inputs)
	if (locale === "ro") return ro_components_sandboxshell_sandbox1(inputs)
	if (locale === "fi") return fi_components_sandboxshell_sandbox1(inputs)
	if (locale === "sv") return sv_components_sandboxshell_sandbox1(inputs)
	if (locale === "vi") return vi_components_sandboxshell_sandbox1(inputs)
	if (locale === "tr") return tr_components_sandboxshell_sandbox1(inputs)
	if (locale === "cs") return cs_components_sandboxshell_sandbox1(inputs)
	if (locale === "bg") return bg_components_sandboxshell_sandbox1(inputs)
	if (locale === "ru") return ru_components_sandboxshell_sandbox1(inputs)
	if (locale === "uk") return uk_components_sandboxshell_sandbox1(inputs)
	if (locale === "ar") return ar_components_sandboxshell_sandbox1(inputs)
	if (locale === "hi") return hi_components_sandboxshell_sandbox1(inputs)
	if (locale === "th") return th_components_sandboxshell_sandbox1(inputs)
	if (locale === "ja") return ja_components_sandboxshell_sandbox1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_sandbox1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_sandbox1(inputs)
	return ko_components_sandboxshell_sandbox1(inputs)
});
export { components_sandboxshell_sandbox1 as "components.sandboxShell.sandbox" }